module.exports = __webpack_public_path__ + "static/img/doll_t.678b4dd7.png";